import { Drawer, Stack } from '@mantine/core';
import { IconLabel, IconShirt, IconUser } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';
import type { IStore } from '../../interfaces/Store';
import ServiceLabelSelector from '../ServiceLabelSelector';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IOrder } from '../../interfaces/Order';
import { tryPrintLabel, tryPrintTicket } from '../../utils/ticketHelper';
import DrawerActionCard from '../DrawerActionCard';

interface PrintTicketDrawerProps {
  opened: boolean;
  onClose: () => void;
  order: IOrder | null;
}

const PrintTicketDrawer = ({ opened, onClose, order }: PrintTicketDrawerProps) => {
  const labelIcon = <IconLabel />;
  const { t } = useTranslation(['CommonButtons', 'OrdersCardMoreActionMenu', 'Labels']);
  const { company } = useSelector((state: any) => state.user);
  const isDisabled = !order;
  const [serviceLabelsOpened, serviceLabels] = useDisclosure(false);
  const labelStore = typeof order?.createdIn === 'object' ? order.createdIn : order?.createdIn ? { _id: order.createdIn } as IStore : null;

  const onPrintTicket = async (
    ticketStructureConfig: 'ticketForLaundryStructure' | 'ticketStructure'
  ) => {
    if (!order) return;
    try {
      tryPrintTicket(
        order,
        order.createdIn,
        t,
        ticketStructureConfig,
        company?.logoUrl || '',
        false,
        company?.companyTaxInfo
      );
    } catch (e) {}
    onClose();
  };

  const onPrintLabelTicket = async () => {
    if (!order) return;
    try {
      await tryPrintLabel(order, order.createdIn, t, [], company?.logoUrl || '');
    } catch (e) {}
    onClose();
  };

  return (
    <>
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      title={t('CommonButtons:printTicket.title')}
      padding="md"
      size="sm">
      <Stack gap="sm">
        <DrawerActionCard
          label={t('OrdersCardMoreActionMenu:printTicketSheetOptions.customerTicket')}
          icon={<IconUser />}
          iconColor="blue"
          onClick={() => onPrintTicket('ticketStructure')}
          disabled={isDisabled}
          ariaLabel={t('OrdersCardMoreActionMenu:printTicketSheetOptions.customerTicket')}
        />
        <DrawerActionCard
          label={t('OrdersCardMoreActionMenu:printTicketSheetOptions.laundryTicket')}
          icon={<IconShirt />}
          iconColor="teal"
          onClick={() => onPrintTicket('ticketForLaundryStructure')}
          disabled={isDisabled}
          ariaLabel={t('OrdersCardMoreActionMenu:printTicketSheetOptions.laundryTicket')}
        />
        <DrawerActionCard
          label={t('Labels:orderMode')}
          icon={labelIcon}
          iconColor="lime"
          onClick={onPrintLabelTicket}
          disabled={isDisabled}
          ariaLabel={t('Labels:orderMode')}
        />
        <DrawerActionCard
          label={t('Labels:serviceMode')}
          icon={labelIcon}
          iconColor="lime"
          onClick={serviceLabels.open}
          disabled={isDisabled || !labelStore}
          ariaLabel={t('Labels:serviceMode')}
        />
      </Stack>
    </Drawer>
    {labelStore && <ServiceLabelSelector opened={opened && serviceLabelsOpened} onClose={serviceLabels.close} orderId={order?._id || ''} store={labelStore} logo={company?.logoUrl || ''} />}
    </>
  );
};

export default PrintTicketDrawer;
